var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tongji-container" },
    [
      _c(
        "el-card",
        { staticClass: "filter-card" },
        [
          _c(
            "el-form",
            {
              staticClass: "form",
              attrs: { inline: true },
              model: {
                value: _vm.form,
                callback: function ($$v) {
                  _vm.form = $$v
                },
                expression: "form",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "开始日期" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.form.startDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "startDate", $$v)
                      },
                      expression: "form.startDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "结束日期" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.form.endDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "endDate", $$v)
                      },
                      expression: "form.endDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "button-item", attrs: { label: " " } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "primary" },
                      on: { click: _vm.handleQuery },
                    },
                    [_vm._v(" 查询统计 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "stats-row", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [_vm._v("总检测")]),
                _c("div", { staticClass: "stat-value text-primary" }, [
                  _vm._v(_vm._s(_vm.data.totalCount)),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [_vm._v("日均检测")]),
                _c("div", { staticClass: "stat-value text-success" }, [
                  _vm._v(
                    _vm._s(
                      (_vm.data.totalCount / _vm.data.countTotalDays).toFixed(2)
                    )
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v("平和质占比"),
                ]),
                _c("div", { staticClass: "stat-value text-info" }, [
                  _vm._v(_vm._s(_vm.data.phy1Ratio) + "%"),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v("偏颇体质占比"),
                ]),
                _c("div", { staticClass: "stat-value text-warning" }, [
                  _vm._v(_vm._s(100 - _vm.data.phy1Ratio) + "%"),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-card", { staticClass: "chart-card" }, [
        _c("div", { attrs: { slot: "header" }, slot: "header" }, [
          _c("span", [_vm._v("每日检测人数趋势")]),
        ]),
        _c("div", {
          ref: "dailyChart",
          staticClass: "chart-container",
          staticStyle: { height: "400px" },
        }),
      ]),
      _c(
        "el-card",
        { staticClass: "table-card" },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [_vm._v("每日体质检测明细")]),
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                stripe: "",
                "show-summary": "",
                "summary-method": _vm.getSummaries,
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "date", label: "日期", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "robotName",
                  label: "设备编号",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "门店名称",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "totalCount",
                  label: "检测总人数",
                  align: "center",
                },
              }),
              _vm._l(_vm.constitutionTypes, function (item) {
                return _c("el-table-column", {
                  key: item.key,
                  attrs: { prop: item.key, label: item.label, align: "center" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "clickable-number",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleConstitutionClick(
                                      scope.row,
                                      item.key
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row[item.key]))]
                            ),
                            _c("div", { staticClass: "ratio-text" }, [
                              _vm._v(_vm._s(scope.row[item.key + "Percent"])),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c("el-card", { staticClass: "chart-card" }, [
        _c("div", { attrs: { slot: "header" }, slot: "header" }, [
          _c("span", [_vm._v("体质类型分布占比")]),
        ]),
        _c("div", {
          ref: "pieChart",
          staticClass: "chart-container",
          staticStyle: { height: "400px" },
        }),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "92%",
            top: "4vh",
            "close-on-click-modal": false,
            "custom-class": "phy-dialog",
            "z-index": 2000,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.dialogVisible
            ? _c("PhyDiagRecord2", {
                attrs: { "dialog-query": _vm.dialogQuery },
                on: {
                  close: function ($event) {
                    _vm.dialogVisible = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }